/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface StorageControllerDownloadFile$Params {
  key: string;
}

export function storageControllerDownloadFile(
  http: HttpClient,
  rootUrl: string,
  params: StorageControllerDownloadFile$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(
    rootUrl,
    storageControllerDownloadFile.PATH,
    'get',
  );
  if (params) {
    rb.path('key', params.key, {});
  }

  return http
    .request(
      rb.build({
        responseType: 'blob',
        accept: 'application/octet-stream',
        context,
      }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      }),
    );
}

storageControllerDownloadFile.PATH = '/storage/download/key/{key}';
